import * as React from "react"
import pretty from "pretty";
import { Page } from "./clay/Page";
import { fetchRecord, storeRecord, useQuery, useRecordQuery } from "./clay/api";
import { AI_ARTICLE_META } from "./app/ai/articles/table";
import { Badge, Button } from "react-bootstrap";
import usePromise from "react-use-promise";
import { pull } from "lodash-es";
import e from "express";

const { Parser } = require("htmlparser2/lib/index");
const { DomHandler } = require("domhandler");

function textForDom(dom: any) {
  if (dom.type === 'text') {
    return dom.data
  } else if (dom.type === 'tag') {
    return dom.children.map((x: any) => textForDom(x)).join('')
  } else {
    return ''
  }
}

function pullRearrangeData(data: string) {
  return new Promise((resolve, reject) => {
            const handler = new DomHandler(
                async (error: any, dom: any) => {
                    const schoolCards: any[] = [];
                    let previous =  null

                    function processSchoolCardList(node: any) {
                        if (node.type === "tag") {
                            if (node.name === "SchoolCard") {
                                schoolCards.push(node);
                            } else if (node.name === "PreviousOrder") {
                              previous = node;
                            } else {
                                for (const child of node.children) {
                                    processSchoolCardList(child);
                                }
                            }
                        }
                    }

                    function processChildren(nodes: any[]) {
                        for (const node of nodes) {
                            if (node.type == "tag") {
                                if (node.name === "SchoolCardList") {
                                    processSchoolCardList(node);

                                    return false;
                                } else {
                                    if (!processChildren(node.children)) {
                                        return false;
                                    }
                                }
                            }
                        }
                        return true;
                    }

                    processChildren(dom);

                    const slugs = schoolCards.map((card) => card.attribs.slug);

                    const response = await fetch(
                        "https://staging.academicinfluence.com/internal/api/rerank",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(slugs),
                        }
                    );

                    const data = await response.json();

                    resolve({ schoolCards, newOrder: data, dom, previous });
                },
                {
                    withStartIndices: true,
                    withEndIndices: true,
                }
            );
            const parser = new Parser(handler, {
                decodeEntities: true,
                lowerCaseTags: false,
                recognizeSelfClosing: true,
            });
            parser.parseComplete(data);
          })
        }

        async function applyRewrite(rewriteData: any, data: string, title: string) {

            const changes: {
              from: number,
              to: number,
              insert: string
            }[] = [];
            const slugs: string[] = rewriteData.schoolCards.map(
                (x: any) => x.attribs.slug
            );

            if (rewriteData.previous) {
              changes.push({
                from: rewriteData.previous.startIndex,
                to: rewriteData.previous.endIndex + 1,
                insert: ''
            })
            }

            let intro_start = null;
            let intro_done = false;
            for (const node of rewriteData.dom) {
              if (node.type === "tag" && node.name === "Card") {
                for (const subnode of node.children) {
                  if (subnode.type === "tag") {
                    if (/Ranking Update/.test(textForDom(subnode))) {
                      changes.push({
                        from: node.startIndex,
                        to: node.endIndex + 1,
                        insert: ''
                      })
                    }

                    break;
                  }
                }
              } else if (node.type == "tag" && node.name == "p") {
                if (intro_start === null) {
                  intro_start = node.startIndex;
                }
              } else if (node.type == "tag" && node.name == "h1" || node.name === "h2" || node.name == "h3" || node.name == "h4" || node.name == "h5") {
                intro_done = true;
              } else if (node.type === "tag") {
                if (intro_start !== null && !intro_done) {
                  intro_done = true;
                  const reader = await fetch("https://staging.inkwell.net/api/secret", {
                    method: "POST",
                    body: `Title: ${title}
                    
                    ${data.substring(intro_start, node.startIndex)}`
                  })

                  const apidata = await reader.json()
                  changes.push({
                    from: intro_start,
                    to: node.startIndex,
                    insert: apidata.html
                  })

                }
              }
            }

            const formattedHiddenElement =
                "\n" +
                pretty(`<PreviousOrder prev-order="${slugs}" />`) +
                "\n\n";

            if (rewriteData.schoolCards.length > 0) {
            changes.push({
                from: rewriteData.schoolCards[0].startIndex,
                to: rewriteData.schoolCards[0].startIndex,
                insert: formattedHiddenElement,
            });
          }

            for (
                let index = rewriteData.schoolCards.length - 1;
                index >= 0;
                index--
            ) {
                const card = rewriteData.schoolCards[index];
                let source = slugs.indexOf(rewriteData.newOrder[index]);
                if (source === -1) {
                  changes.push({
                      from: card.startIndex,
                      to: card.endIndex + 1,
                      insert: ''
                  });
                  continue;
  
                }
                const sourceCard = rewriteData.schoolCards[source];

                changes.push({
                    from: card.startIndex,
                    to: card.endIndex + 1,
                    insert: data.substring(
                        sourceCard.startIndex,
                        sourceCard.endIndex + 1
                    ),
                });
            }

            return changes
          }

async function resolveArticle(article_id: string) {
  const article = await fetchRecord(AI_ARTICLE_META, article_id)
  if (!article) {
    throw new Error("Missing article")
  }
  const rewriteData = await pullRearrangeData(article?.content)
  const title = article.title.replace(/\b202[012345]/g, '2026')
  const changes = await applyRewrite(rewriteData, article.content, title)

  changes.sort((a, b) => {
    if (a.from == b.from) {
      return b.to - a.to
    } else {
      return b.from - a.from
    }
  })

  let data = article.content
  for (const change of changes) {
    data = data.substring(0, change.from) + change.insert + data.substring(change.to)
  }

  changes.sort((a, b) => {
    if (a.from == b.from) {
      return a.to - b.to
    } else {
      return a.from - b.from
    }
  })

  let heroImageBannerAltText = article.heroImageBannerAltText

  if (/^hero-badge\/202[012345]\//.test(article.heroImageBannerAltText)) {
    heroImageBannerAltText = heroImageBannerAltText.replace(/202[012345]/, '2026')
  }

  return {
    record: article,
    old: article.title,
    new: title,
    content: data,
    heroImageBannerAltText,
    changes: changes.map(x => ({...x, old: article.content.substring(x.from, x.to)})).filter(x => x.old != x.insert)
  }

}


export const MAGIC_REWRITER = {
  initialize() {
    return {state: null, requests: []}
  },
  reduce() {
    return {state: null, requests: []}
  },
  headerComponent() {
    return <>Magic Rewriter</>
  },
  component() {
    const articles$ = useQuery({tableName: "AiArticle", columns: ["id", "title"],

    }, []) 
    const articles = React.useMemo(() => articles$|| [], [articles$])


    const oldArticles = React.useMemo(() => articles.filter(x => /\b202[012345]\b/.test((x[1] as string))),[articles])

    const activeArticles = React.useMemo(() => oldArticles.slice(0, 20
    ), [oldArticles])

    const transformed = usePromise(() => {
      return Promise.all(activeArticles.map(x => resolveArticle(x[0] as string)))
    }, [activeArticles])


    async function onApply() {
      const options = transformed[0]!
      for (const option of options) {
        const newrecord ={...option.record, title: option.new, content: option.content,  heroImageBannerAltText: option.heroImageBannerAltText}
        await storeRecord(AI_ARTICLE_META, 'magic rewriter', newrecord)
      }
      alert("Done")

    }


    return <>
      <Badge variant="info">{articles.length} articles</Badge>
      <Badge variant="info">{oldArticles.length} out-of-date articles</Badge>
      {transformed[2]}
      {transformed[1]?.stack}
      <Button onClick={onApply}>Apply</Button>
      {transformed[2] === 'resolved' && transformed[0].map(x => <>
        <h1>{x.old} -&gt; {x.new}</h1>
        <table>
          <tr>
            <td>{x.record.heroImageBannerAltText}</td>
            <td>{x.heroImageBannerAltText}</td>
          </tr>
          {x.changes.map(change => <tr>
            <td>{change.old}</td>
            <td>{change.insert}</td>
          </tr>)}
        </table>
      </>)}
    </>;
  },
  encodeState(state) {
      return {segments: [], parameters: {}}
  },
  title() {
    return "Magic Rewriter"
  },
  hasUnsavedChanges(state) {
      return false;
  },
  beforeUnload(state) {
      return false
  },
} satisfies Page<null, never>;

function escapeHtml(unsafe: string) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
